import { Link } from "react-router-dom";

 function TermsAndConditions() {
  return (
    <main className="mx-auto max-w-4xl px-4 pb-20 pt-10 sm:px-6">
      <article className="paper-card p-6 sm:p-10">
        <h1 className="text-4xl font-extrabold" style={{ color: "#ef852e" }}>
          Terms and Conditions
        </h1>

        <p className="mt-3 text-sm text-muted-foreground">
          Last updated: August 25, 2026
        </p>

        <p className="mt-6 leading-7">
          These Terms and Conditions govern your use of Kid&apos;s Sermon
          Builder. By accessing or using the service, you agree to these terms.
          If you do not agree with these terms, please do not use the service.
        </p>

        <h2 className="mt-10 text-2xl font-extrabold" style={{ color: "#ef852e" }}>
          1. About Kid&apos;s Sermon Builder
        </h2>

        <p className="mt-4 leading-7">
          Kid&apos;s Sermon Builder is an educational lesson-planning tool
          designed to help children&apos;s pastors, ministry leaders, Sunday
          school teachers, parents, and others create engaging Bible lessons
          for children.
        </p>

        <p className="mt-4 leading-7">
          The application may provide Bible stories, teaching points, games,
          object lessons, illustrations, narration, and other educational
          materials.
        </p>

        <h2 className="mt-10 text-2xl font-extrabold" style={{ color: "#ef852e" }}>
          2. Eligibility and Account
        </h2>

        <p className="mt-4 leading-7">
          You are responsible for providing accurate information when creating
          an account and for keeping your account credentials secure.
        </p>

        <p className="mt-4 leading-7">
          You are responsible for all activity that occurs through your
          account.
        </p>

        <h2 className="mt-10 text-2xl font-extrabold" style={{ color: "#ef852e" }}>
          3. Use of the Service
        </h2>

        <p className="mt-4 leading-7">
          You agree to use Kid&apos;s Sermon Builder only for lawful purposes
          and in accordance with these Terms.
        </p>

        <p className="mt-4 leading-7">
          You must not attempt to interfere with the operation or security of
          the service, gain unauthorized access to systems, abuse automated
          services, or use the application in a way that could harm other
          users or the service.
        </p>

        <h2 className="mt-10 text-2xl font-extrabold" style={{ color: "#ef852e" }}>
          4. AI-Generated Content
        </h2>

        <p className="mt-4 leading-7">
          Some content provided by Kid&apos;s Sermon Builder may be generated
          using artificial intelligence.
        </p>

        <p className="mt-4 leading-7">
          AI-generated content may contain errors, omissions, inaccuracies, or
          inappropriate suggestions. You are responsible for reviewing all
          generated content before using it in a church service, classroom,
          family devotional, or other teaching environment.
        </p>

        <p className="mt-4 leading-7">
          In particular, Scripture references, theological statements, lesson
          content, and educational recommendations should be independently
          reviewed for accuracy.
        </p>

        <h2 className="mt-10 text-2xl font-extrabold" style={{ color: "#ef852e" }}>
          5. User-Generated Content
        </h2>

        <p className="mt-4 leading-7">
          You may create, save, and manage lesson content through the service.
          You are responsible for the content you submit or create.
        </p>

        <p className="mt-4 leading-7">
          Do not submit confidential, sensitive, or unnecessary personal
          information about children or other individuals.
        </p>

        <h2 className="mt-10 text-2xl font-extrabold" style={{ color: "#ef852e" }}>
          6. Intellectual Property
        </h2>

        <p className="mt-4 leading-7">
          The Kid&apos;s Sermon Builder application, branding, interface,
          software, logos, and other original materials are protected by
          applicable intellectual property laws.
        </p>

        <p className="mt-4 leading-7">
          You may use lesson materials generated through the service for
          legitimate teaching and ministry purposes, subject to any applicable
          third-party rights and the terms of the services used to generate
          that content.
        </p>

        <h2 className="mt-10 text-2xl font-extrabold" style={{ color: "#ef852e" }}>
          7. Subscriptions
        </h2>

        <p className="mt-4 leading-7">
          Kid&apos;s Sermon Builder is free to download. We may offer
          auto-renewing subscriptions that provide access to premium features
          and expanded lesson libraries.
        </p>

        <p className="mt-4 leading-7">
          Payment will be charged to your Apple ID account at confirmation of
          purchase.
        </p>

        <p className="mt-4 leading-7">
          Your subscription automatically renews unless you cancel it at least
          24 hours before the end of the current subscription period.
        </p>

        <p className="mt-4 leading-7">
          Your account will be charged for renewal within 24 hours before the
          end of the current subscription period.
        </p>

        <p className="mt-4 leading-7">
          You can manage or cancel your subscription through your App Store
          account settings after purchase.
        </p>

        <h2 className="mt-10 text-2xl font-extrabold" style={{ color: "#ef852e" }}>
          8. Free Features and Premium Features
        </h2>

        <p className="mt-4 leading-7">
          We may change, add, remove, or modify free and premium features from
          time to time. Some features may require an active subscription.
        </p>

        <p className="mt-4 leading-7">
          We do not guarantee that any particular feature will remain available
          indefinitely.
        </p>

        <h2 className="mt-10 text-2xl font-extrabold" style={{ color: "#ef852e" }}>
          9. Availability of the Service
        </h2>

        <p className="mt-4 leading-7">
          We aim to keep Kid&apos;s Sermon Builder available and reliable, but
          we do not guarantee uninterrupted or error-free operation.
        </p>

        <p className="mt-4 leading-7">
          The service may occasionally be unavailable because of maintenance,
          updates, technical problems, third-party service interruptions, or
          circumstances outside our control.
        </p>

        <h2 className="mt-10 text-2xl font-extrabold" style={{ color: "#ef852e" }}>
          10. Third-Party Services
        </h2>

        <p className="mt-4 leading-7">
          Kid&apos;s Sermon Builder may depend on third-party services for
          hosting, artificial intelligence, email, storage, authentication,
          payments, or other functionality.
        </p>

        <p className="mt-4 leading-7">
          We are not responsible for interruptions, errors, or changes made by
          third-party services.
        </p>

        <h2 className="mt-10 text-2xl font-extrabold" style={{ color: "#ef852e" }}>
          11. Disclaimer
        </h2>

        <p className="mt-4 leading-7">
          Kid&apos;s Sermon Builder is a lesson-planning and educational
          resource. It is not a substitute for professional theological
          judgment, pastoral guidance, educational supervision, or independent
          review of Scripture.
        </p>

        <p className="mt-4 leading-7">
          You are responsible for determining whether generated or provided
          materials are appropriate for your audience, church, ministry,
          classroom, or family.
        </p>

        <h2 className="mt-10 text-2xl font-extrabold" style={{ color: "#ef852e" }}>
          12. Limitation of Liability
        </h2>

        <p className="mt-4 leading-7">
          To the maximum extent permitted by applicable law, Kid&apos;s Sermon
          Builder and its operators will not be responsible for indirect,
          incidental, special, consequential, or similar damages arising from
          your use of or inability to use the service.
        </p>

        <h2 className="mt-10 text-2xl font-extrabold" style={{ color: "#ef852e" }}>
          13. Account Termination
        </h2>

        <p className="mt-4 leading-7">
          We may suspend or terminate accounts that violate these Terms,
          interfere with the service, or are involved in abusive, fraudulent,
          or unlawful activity.
        </p>

        <p className="mt-4 leading-7">
          You may stop using the service at any time.
        </p>

        <h2 className="mt-10 text-2xl font-extrabold" style={{ color: "#ef852e" }}>
          14. Changes to These Terms
        </h2>

        <p className="mt-4 leading-7">
          We may update these Terms and Conditions from time to time. The
          updated version will be posted with a revised effective date.
        </p>

        <p className="mt-4 leading-7">
          Your continued use of Kid&apos;s Sermon Builder after changes are
          posted constitutes acceptance of the updated terms, to the extent
          permitted by applicable law.
        </p>

        <h2 className="mt-10 text-2xl font-extrabold" style={{ color: "#ef852e" }}>
          15. Contact
        </h2>

        <p className="mt-4 leading-7">
          If you have questions about these Terms and Conditions, please
          contact the Kid&apos;s Sermon Builder support team through the
          contact information provided by the service.
        </p>

        <div className="mt-10 border-t pt-6">
          <Link
            to="/"
            className="font-bold underline"
            style={{ color: "#ef852e" }}
          >
            Back to Kid&apos;s Sermon Builder
          </Link>
        </div>
      </article>
    </main>
  );
}

export default  TermsAndConditions;